





















import Vue, { PropType } from 'vue'

import { DirectMessage } from '../../../base/store/state.interface'
import { Widget } from '../base'

import DirectMessagesItem from './DirectMessagesItem.vue'
import NoWidgetAccess from '../../components/NoWidgetAccess.vue'

export default Vue.extend({
  components: {
    DirectMessagesItem,
    NoWidgetAccess,
  },
  props: {
    widget: {
      required: true,
      type: Object as PropType<Widget>
    }
  },
  computed: {
    showTitle() {
      return this.widget?.customSettings?.settings.showTitle.checked
    },
    filteredMessages() {
      const dm = this.$store.state.dm
      const items = dm.items
      const sorting = dm.sorting
      const result: DirectMessage[] = []
      const filterUnreadOnly = this.widget.customSettings!.settings.unreadonly.checked

      sorting.forEach(id => {
        const item = items[id] as DirectMessage
        if (!item || (filterUnreadOnly && !item.new)) return

        result.push(item)
      })

      return result
    },
    numItems(): number {
      return this.filteredMessages ? this.filteredMessages.length : 0
    }
  }
})
